// @flow
import * as React from 'react';
import { SplitComposerModal } from 'chat/components/SplitComposer';
import {
  clearDraftAnnouncement,
  DraftAnnouncementContainer,
} from 'groups/actions/DraftMessageActions';

type Props = {
  onRequestHide: () => void,
};

class DraftedComposer extends React.Component<Props> {
  componentDidMount() {
    clearDraftAnnouncement();
  }

  render() {
    const { onRequestHide } = this.props;
    return (
      <DraftAnnouncementContainer>
        {({ draftAnnouncement }) => {
          const targets = draftAnnouncement ? draftAnnouncement.getTargets() : [];

          if (draftAnnouncement) {
            return (
              <SplitComposerModal
                initialTargets={targets}
                draftAnnouncement={draftAnnouncement}
                onRequestHide={onRequestHide}
                skipSelectRecipients
              />
            );
          }
          return <SplitComposerModal onRequestHide={onRequestHide} />;
        }}
      </DraftAnnouncementContainer>
    );
  }
}

export default DraftedComposer;
